export default {
  loading: false,
  appList: [],
  selectedApp: {},
  appConfig: null,
  appConfigUpdated: null,
  appsWithoutFilter: [],
  showAboutModal: false,
  showConfigModal: false,
  showEditModal: false,
  showReportProblemModal: false,
  appNameFilterFieldValue: '',
  appListFilter: {},
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations/store/states.js